import {
  AiOutlineCalendar,
  AiOutlineCamera,
  AiOutlineSetting,
} from "react-icons/ai";
import asTabBarIcon from "utils/asTabBarIcon";

export const EventTabIcon = asTabBarIcon(AiOutlineCalendar);

export const ScannerTabIcon = asTabBarIcon(AiOutlineCamera);

export const SettingsTabIcon = asTabBarIcon(AiOutlineSetting);
